/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Readonly_LineInputs */

const vi_einvoice_draft_readonly_line = /** @type {(inputs: Einvoice_Draft_Readonly_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng cố định trên nháp`)
};

/**

* @param {Einvoice_Draft_Readonly_LineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_readonly_line = /** @type {((inputs?: Einvoice_Draft_Readonly_LineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Readonly_LineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_readonly_line(inputs)
});